import React from "react"
import SkillSet from './common/SkillSet';

export default function Skill() {
  return <div>
    <img
          className="h-96 m-auto w-auto md:h-48"
          src={`img/y0703.png`}
          alt="image of Skill"
      />
    <div>
      <p className='border-l-4 border-yellow-200 mt-10 ml-4'>Language</p>
      <SkillSet
        skillName='javascript'
        years='5'
        imgUrl='javascript.svg'
        level={4}
      />
      <SkillSet
        skillName='typescript'
        years='3'
        imgUrl='typescript-icon.svg'
        level={4}
      />
      <SkillSet
        skillName='java'
        years='2'
        imgUrl='java.svg'
        level={3}
      />
      <SkillSet
        skillName='C#'
        years='2'
        imgUrl='c-sharp.svg'
        level={3}
      />
      <SkillSet
        skillName='SQL'
        years='3'
        imgUrl='mysql.svg'
        level={3}
      />
      <SkillSet
        skillName='HTML'
        years='5'
        imgUrl='html-5.svg'
        level={4}
      />
      <SkillSet
        skillName='CSS'
        years='5'
        imgUrl='css-3.svg'
        level={4}
      />
      <p className='border-l-4 border-yellow-200 mt-10 ml-4'>Flamework</p>
      <SkillSet
        skillName='React'
        years='3'
        imgUrl='react.svg'
        level={4}
      />
      <SkillSet
        skillName='Angular'
        years='2'
        imgUrl='angular-icon.svg'
        level={3}
      />
      <SkillSet
        skillName='Express'
        years='2'
        imgUrl='express.svg'
        level={3}
      />
      <p className='border-l-4 border-yellow-200 mt-10 ml-4'>Cloud</p>
      <SkillSet
        skillName='Azure'
        years='2'
        imgUrl='azure-icon.svg'
        level={4}
      />
      <SkillSet
        skillName='AWS'
        years='1'
        imgUrl='aws.svg'
        level={2}
      />
      <p className='border-l-4 border-yellow-200 mt-10 ml-4'>Developing</p>
      <SkillSet
        skillName='scrum'
        years='2'
        imgUrl='scrum.png'
        level={3}
      />
      <SkillSet
        skillName='DevOps'
        years='2'
        imgUrl='devops.png'
        level={3}
      />
    </div>
  </div>
}
